import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { AffiliatesLink } from './AffiliatesLink';

interface CommissionPlanProps {
  variant: 'footer' | 'header';
}

export const CommissionPlan = ({ variant }: CommissionPlanProps) => (
  <AffiliatesLink variant={variant} path="/commission-plan/" category={'Commission Plan'}>
    <I18n k="affiliates_signup_perseus.commission_plan" />
  </AffiliatesLink>
);
